import { Fragment } from 'react'
import { AssetReference } from '@opallabs/cassini'
import { Asset } from '@opallabs/kuiper'
import { AccountName } from '@opallabs/periodic/src/AccountName'
import { ContentAvatar } from '@opallabs/periodic/src/ContentAvatar'
import { sharedColors } from '../../../sharedStyles/styles'
import { styles } from './styles'

export interface Props {
  accountImage: AssetReference | null
  accountName: string
  image: AssetReference | null
  isPresenting: boolean
  onExpandAsset: (assetId: number) => void
  onRemoveAsset: (assetId: number) => void
  readOnly: boolean
}

export const DesktopStandard: React.FC<Props> = ({
  accountImage,
  accountName,
  image,
  isPresenting,
  onExpandAsset,
  onRemoveAsset,
  readOnly,
}) => (
  <Fragment>
    <Asset
      hasAssetOverlay={!readOnly || isPresenting}
      assetReference={image}
      placeholder={!image}
      overrideStyles={{
        asset: styles.coverAsset,
        assetBase: styles.coverAsset,
      }}
      onEmbiggen={() => onExpandAsset(image?.id || 0)}
      onRemove={() => onRemoveAsset(image?.id || 0)}
    />
    <div css={styles.channel}>
      <div css={styles.accountWrapper}>
        <ContentAvatar size={80} assetReference={accountImage} />
        <div css={styles.accountInfo}>
          <AccountName
            name={accountName}
            style={styles.accountName}
            size={25}
            color={sharedColors.black}
          />
          <span css={styles.subscriberTxt}># subscribers</span>
        </div>
      </div>
      <div css={styles.subscribeBtn}>Subscribe</div>
    </div>
  </Fragment>
)
